import getCart from './getCart';

const getCartTotal = state => getCart(state)?.total;

export default getCartTotal;
